import React from 'react';

const LayoutBackground = (props: { children: JSX.Element }) => (
  <div
    className={`flex md:bg-fixed flex-col h-screen w-screen shadow-inner md:flex-row bg-gradient-to-bl  to-primary-400 from-secondary-800`}
  >
    {props.children}
  </div>
);

export default LayoutBackground;
